import Dough from "../Dough";
import common from "../../../common";
import Swipe from "../../../reusableModules/Swipe";
import ParticleEmitter from "../../../reusableModules/ParticleEmitter";
import TutorialFinger from "../../../reusableModules/TutorialFinger";

export default class doughRolling extends PIXI.Container {
    constructor() {
        super();
        this._innerContainer = null;
        this._dough = null;
        this._rollingPin = null;
        this._swipe = null;
        this._tutorialFinger = null;
        this._flourEmiiters = [];
        this._rollerEmitter = null;
        this._swipeCounter = 0;
        this._allowDoughAnimation = false;

        this._swipingComplete = false;
        this._doughAnimatingComplete = false;

        this._bindings = {};
        this._signals = {};
        this._signals.rollingComplete = new P3.utils.MiniSignal();

        this.init();
    }

    init(){
        this._innerContainer = new PIXI.Container();
        this.addChild(this._innerContainer);

        this.createDough();
        this.createRollingPin();
        this.initialiseSwiping();
        this.createRollerEmitter();
        this.createTutorial();
    }

    update() {

        this._dough.update(P3.Ticker.dt, this._allowDoughAnimation);

        if(this._rollerEmitter){
           // this._rollerEmitter.position.set(this._rollingPin.x, this._rollingPin.y);
            this._rollerEmitter.update();
        }

        for (let emitter of this._flourEmiiters){
            emitter.update();
        }

        if(this._tutorialFinger !== null)
            this._tutorialFinger.update();

        this._allowDoughAnimation = false;
    }

    destroy(){
        for (const i in this._bindings) {
            if (this._bindings.hasOwnProperty(i)) {
                const binding = this._bindings[i];
                binding.detach();
            }
        }
        this._bindings = {};
        this._swipe.destroy();
    }

    initialiseSwiping(){
        this._swipe = new Swipe(Swipe.DIRECTION_HORIZONTAL,-1);
        this._swipe.hitArea = new PIXI.Rectangle(this._dough.x - this._dough.width * 0.5, this._dough.y - this._dough.height * 0.5, this._dough.width, this._dough.height);
       // this._dough.addChildAt(this._swipe, 0);
        this._innerContainer.addChildAt(this._swipe, 0);
        this._bindings.singleSwipe = this._swipe.signals.singleSwipe.add(this.onSwipeReceived, this);
        this._bindings.swipingComplete = this._swipe.signals.swipingComplete.add(this.onRollingComplete, this);
        this._bindings.swipeStart = this._swipe.signals.swipeStart.add((event)=>{
            this._mouseDown = true;
            if(this._rollerEmitter && this._rollerEmitter._emitter){
                let newPosition = event.data.getLocalPosition(this.parent);
                this._rollerEmitter && this._rollerEmitter.play();
                this._rollerEmitter._emitter.updateOwnerPos(newPosition.x, newPosition.y);
            }

            if(this._tutorialFinger)
                this._tutorialFinger.turnOff();
        }, this);
        this._bindings.swipeEnd = this._swipe.signals.swipeEnd.add(()=>{
            this._mouseDown = false;
            this._rollerEmitter && this._rollerEmitter.turnOff();
        }, this);
        this._bindings.swipeMoving = this._swipe.signals.swipeMoving.add((event)=>{
            this.onSwipeMove(event);
            if(this._tutorialFinger)
                this._tutorialFinger.turnOff();
        }, this);
    }

    onSwipeReceived(){
        this._swipeCounter++;
        if(this._swipeCounter % 2 === 0){
            this.createFlourParticle();
        }
    }

    onSwipeMove(event){
        if(this._mouseDown){
            let newPosition = event.data.getLocalPosition(this.parent);

            if(this._rollerEmitter && this._rollerEmitter._emitter){
                this._rollerEmitter._emitter.updateOwnerPos(newPosition.x, newPosition.y);
            }

            this._rollingPin.x = newPosition.x;

            if(this._rollingPin.x < (this._dough.x - this._dough.width * 0.5)){
                this._rollingPin.x = this._dough.x - this._dough.width * 0.5 + 5;
            }
            else if(this._rollingPin.x > (this._dough.x + this._dough.width * 0.5)){
                this._rollingPin.x = this._dough.x + this._dough.width * 0.5 - 5;
            }
        }
        //play a small section of the animation
        this._allowDoughAnimation = true;
    }

    onRollingComplete(){
        this._rollerEmitter.turnOff();
        this._rollingPin.visible = false;

        this._bindings.singleSwipe.detach();
        this._bindings.swipingComplete.detach();

        this._tutorialFinger.destroy();
        this._tutorialFinger = null;

        this._swipingComplete = true;
        P3.audio.playSound("sfx_stage_complete_00");
        this._bindings.help.detach();
    }

    createTutorial(){
        if(this._tutorialFinger != null){
            this._innerContainer.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

        this._tutorialFinger = new TutorialFinger({x:common.STAGE_WIDTH * 0.5 + 75, y: common.STAGE_HEIGHT * 0.5}, 10, -1);
        this._innerContainer.addChild(this._tutorialFinger);

        this._tutorialFinger.fade(true, 500, false);

        this._tutorialFinger.clickDown();

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: this._dough.x - this._dough.width + 75
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
            .delay(0));

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: this._dough.x + this._dough.width + 75
            }, 2000)
            .easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
            .delay(0));

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: this._dough.x + 75
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Sinusoidal.InOut)
            .delay(0));

        this._tutorialFinger.fade(false, 500, false);
        this._tutorialFinger.addDelay(1000);
        this._tutorialFinger.play();
    }

    createDough(){
        this._dough = new Dough();
        this._dough.scale.set(0.85);
        this._dough.x = common.STAGE_WIDTH * 0.5;
        this._dough.y = common.STAGE_HEIGHT * 0.5;
        this._bindings.doughComplete = this._dough._finishedAnimating.add(()=>{
            this.onRollingComplete();
            this._signals.rollingComplete.dispatch();
        }, this);
        this._innerContainer.addChild(this._dough);
    }

    createRollingPin(){
        this._rollingPin = new PIXI.Container();
        this._rollingPin._view = new PIXI.Sprite(P3.assets.texture("roller"));
        this._rollingPin._view.anchor.set(0.5, 0.5);
        this._rollingPin.scale.set(0.5);
        this._rollingPin.addChild(this._rollingPin._view);
        this._rollingPin.x = common.STAGE_WIDTH * 0.5;
        this._rollingPin.y = common.STAGE_HEIGHT * 0.5;
        this._rollingPin.rotation = 90 * (Math.PI / 180);
        this._innerContainer.addChild(this._rollingPin);

        this._hit = new PIXI.Container();
        this._innerContainer.addChild(this._hit);
        this._hit.interactive = true;
        this._hit.on('pointermove',(event)=> {
            // if(this._mouseDown){
            //     let newPosition = event.data.getLocalPosition(this.parent);
            //
            //     if(this._rollerEmitter && this._rollerEmitter._emitter){
            //         this._rollerEmitter._emitter.updateOwnerPos(newPosition.x, newPosition.y);
            //     }
            //
            //
            //     this._rollingPin.x = newPosition.x;
            //
            //     if(this._rollingPin.x < (this._dough.x - this._dough.width * 0.5)){
            //         this._rollingPin.x = this._dough.x - this._dough.width * 0.5 + 5;
            //     }
            //     else if(this._rollingPin.x > (this._dough.x + this._dough.width * 0.5)){
            //         this._rollingPin.x = this._dough.x + this._dough.width * 0.5 - 5;
            //     }
            //     console.log("move");
            // }
        });
    }

    createRollerEmitter(){
        let particles = ParticleEmitter.ROLING_PIN_00;

        this._rollerEmitter = new ParticleEmitter(particles, ParticleEmitter.SPARKLE, true);
        this._innerContainer.addChildAt(this._rollerEmitter, 2);
        //this._innerContainer.addChild(this._rollerEmitter);
        this._rollerEmitter.enableLoop();
        let temp = this._rollerEmitter._config;
        temp.spawnRect = {
            "x": -62.5,
            "y": -250,
            "w": 125,
            "h": 500
        };
        temp.maxParticles = 150;
        this._rollerEmitter.overrideDefaultConfig(temp);
        //this._rollerEmitter.play();
    }

    createFlourParticle(){
        let particles = ParticleEmitter.BOWL_FLOUR_BURST_00;

        let emitter = new ParticleEmitter(particles, ParticleEmitter.FLOUR_CLOUD, false);
        emitter.position.set(common.getRandomInt(this._dough.x - this._dough.width * 0.5, this._dough.x + this._dough.width * 0.5),
            common.getRandomInt(this._dough.y - this._dough.height * 0.5, this._dough.y + this._dough.height * 0.5));
        this._innerContainer.addChild(emitter);
        let config = emitter._config;
        config.blendMode = "add";
        emitter.overrideDefaultConfig(config);
        emitter.play();
        this._flourEmiiters.push(emitter);
    }
}